// extracted by mini-css-extract-plugin
export var addButton = "_e1-0";
export var border = "_e1-8";
export var check = "_e1-h";
export var danger = "_e1-6";
export var dropdownContainer = "_e1-1";
export var editModalBody = "_e1-j";
export var footerContainer = "_e1-i";
export var fullWidth = "_e1-a";
export var hide = "_e1-9";
export var icon = "_e1-3";
export var input = "_e1-7";
export var inputFlex = "_e1-b";
export var inputWrapper = "_e1-c";
export var manualFocus = "_e1-5";
export var optionButton = "_e1-4";
export var pillWrapper = "_e1-e";
export var pointer = "_e1-2";
export var showOverflow = "_e1-f";
export var tagsFlex = "_e1-d";
export var xButton = "_e1-g";